export default "__VITE_ASSET__DgeoYcMF__"